import { Box, Tooltip, useMantineTheme } from '@mantine/core';
import { IconCircleArrowUpFilled } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales/index';

export const UpsellIcon = () => {
  const theme = useMantineTheme();
  const { t } = useTranslation();

  return (
    <Tooltip label={t(i18nKeys.NAV.UPSELL)} position="top" radius={6}>
      <Box
        color="blue"
        h={20}
        style={{ pointerEvents: 'auto', filter: 'opacity(1)', cursor: 'default' }}
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
        }}
        variant="transparent"
      >
        <IconCircleArrowUpFilled stroke={1.5} size={20} color={theme.colors.coral[5]} />
      </Box>
    </Tooltip>
  );
};
